export {default} from './company.vue'